'use client';

import { PageHero } from '@/components/shared/PageHero';
import { ContactSection } from '@/components/shared/ContactSection';
import { useTranslations } from '@/i18n/intl';

export default function ContactUsClient() {
  const tCommon = useTranslations('Common');

  return (
    <>
      <PageHero
        title={tCommon('contactUs')}
        breadcrumbs={[
          { label: tCommon('home'), href: '/' },
          { label: tCommon('contactUs') },
        ]}
      />

      <ContactSection />
    </>
  );
}
